import { INotificationPure } from '../../common/models/Notification'
import { GET_NOTIFICATIONS } from '../../constants/api'
import errorHandler from './errorHandler'

export default (token: string, limit?: number) =>
  fetch(GET_NOTIFICATIONS(limit), {
    method: 'GET',
    headers: { Authorization: 'Bearer ' + token },
  })
    .then(errorHandler)
    .then(async (response: Response) => {
      const data: { notifications: INotificationPure[] } = await response.json()
      return {
        notifications:
          data.notifications.map((n) => ({
            ...n,
            dateCreated: new Date(n.dateCreated),
            dateOpened: n.dateOpened ? new Date(n.dateOpened) : undefined,
          })) || [],
      }
    })
